<div class="twofa-verifyEmail">
  <div class="content flex flex-col gap-4">
    <div class="row hint" *ngIf="action==='enable2Fa'">
      We will send a verification code to your email the next time you login.
    </div>
    <div class="flex justify-between items-center">
      <div><span class="header">Your current email: </span> <strong> {{email}}</strong></div>
      <button
        mat-stroked-button
        color="primary"
        [loading]="sendOtpButtonOptions.loading"
        [disabled]="sendOtpButtonOptions.disabled"
        (click)="sendOtpCodeToEmail()"
      >
        {{sendOtpButtonOptions.text}}
      </button>
    </div>
    <div class="row mb-0">
      <mat-form-field *ngIf="sanitizedCode">
        <mat-label>Verification code</mat-label>
        <span matPrefix>{{sanitizedCode}} - &nbsp;</span>
        <input
          matInput
          placeholder="Verification code"
          [(ngModel)]="code"
          (ngModelChange)="validateCode()"
          (keyup.enter)="continue()"
        />
        <mat-hint class="error-hint" *ngIf="error.code">{{error.code}}</mat-hint>
      </mat-form-field>
      <mat-form-field *ngIf="!sanitizedCode" class="no-validator mb-4">
        <mat-label>Verification code</mat-label>
        <input matInput placeholder="Verification code" [(ngModel)]="code" />
      </mat-form-field>
      <div class="ui small message mt-2" *ngIf="error.serverError">{{error.serverError}}</div>
    </div>
  </div>

  <div mat-dialog-actions align="end" style="padding: 0 !important">
    <button mat-stroked-button mat-dialog-close>Cancel</button>
    <button
      mat-raised-button
      [loading]="continueButtonOptions.loading"
      [disabled]="continueButtonOptions.disabled"
      color="primary"
      (click)="continue()"
    >
      Continue
    </button>
  </div>
</div>
